import type { StyleSystemProps } from '@withjoy/joykit';

const slapAdsRegistryWrapper: StyleSystemProps = {
  border: '1px solid',
  borderColor: 'mono3',
};

export const styles = {
  slapAdsRegistryWrapper,
};
